/**
 * @prettier
 */
const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/; // e.g. 2020-11-23T08:46:05.864Z
export function dateReviver(key: string, value: any): any {
    return typeof value == 'string' && dateRegex.test(value) ? new Date(value) : value;
}
